// Capability strings returned by the backend `viewer` query. The backend owns
// the full list; the client only needs to know the ones it gates UI on, and
// ignores any capability string it doesn't recognize.
export const MANAGE_DEVICES = 'MANAGE_DEVICES';

type SessionLike = {
  capabilities?: string[];
} | null | undefined;

// Single place the capability check lives, so gating isn't duplicated as ad-hoc
// string comparisons across Header / route guards.
export function hasCapability(session: SessionLike, capability: string): boolean {
  return Array.isArray(session?.capabilities) && session!.capabilities!.includes(capability);
}
